import React, { useLayoutEffect, useRef } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import './HiveMasterclass.css';

const REGISTER_URL = 'https://forms.gle/7iysYNutbsG6DVceA';
const MIN_FONT_SIZE = 22;

const fitHeadingWidth = heading => {
  if (!heading) return;

  heading.style.fontSize = '';
  heading.style.letterSpacing = '';

  const maxFontSize = parseFloat(window.getComputedStyle(heading).fontSize);
  if (!maxFontSize) return;

  let fontSize = maxFontSize;
  heading.style.fontSize = `${fontSize}px`;
  heading.style.letterSpacing = `${-0.041 * fontSize}px`;

  while (fontSize > MIN_FONT_SIZE && heading.scrollWidth > heading.clientWidth + 1) {
    fontSize -= 0.5;
    heading.style.fontSize = `${fontSize}px`;
    heading.style.letterSpacing = `${-0.041 * fontSize}px`;
  }
};

const HiveMasterclass = () => {
  const headingRef = useRef(null);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.15,
  });

  const animationProps = useSpring({
    transform: inView ? 'translateY(0px)' : 'translateY(24px)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 20 },
  });

  useLayoutEffect(() => {
    const heading = headingRef.current;
    if (!heading) return undefined;

    const runFit = () => fitHeadingWidth(heading);
    runFit();

    const observer = new ResizeObserver(runFit);
    observer.observe(heading);
    if (heading.parentElement) {
      observer.observe(heading.parentElement);
    }

    window.addEventListener('resize', runFit);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', runFit);
    };
  }, []);

  return (
    <animated.div ref={ref} style={animationProps} className="hive-masterclass">
      <div className="hive-masterclass-copy">
        <h2 ref={headingRef} className="hive-masterclass-heading">
          Cracking TikTok, Reels &amp;
          <br />
          Google for SME growth:
        </h2>
        <p className="hive-masterclass-subheading">
          Join our{' '}
          <span className="hive-masterclass-subheading-emphasis">free</span>{' '}
          bi-weekly{' '}
          <span className="hive-masterclass-subheading-strong">
            Inside The Hive
          </span>{' '}
          masterclass.
        </p>
      </div>
      <a
        className="hive-masterclass-button"
        href={REGISTER_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Register Here
      </a>
    </animated.div>
  );
};

export default HiveMasterclass;
